export function parseAnswerValue(value: string | undefined | null): string[] {
  if (!value) return [];
  if (value.startsWith("[")) {
    try {
      const parsed: unknown = JSON.parse(value);
      if (Array.isArray(parsed))
        return parsed.filter((v): v is string => typeof v === "string");
    } catch {
      return [];
    }
    return [];
  }
  return [value];
}

export function serializeAnswerValue(ids: string[]): string {
  return JSON.stringify(ids);
}
